// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuefire from 'vuefire'
// import VueResource from 'vue-resource'
import Vuetify, {
  // VRow,
  // VContainer,
  // VColumn,
  transitions, VApp, VAutocomplete, VBtn, VCard, VCheckbox, 
  VChip, VDataIterator, VDataTable, VDatePicker, VDialog, VDivider, 
  VExpansionPanel, VFooter, VForm, VGrid, VIcon, VImg, VList, VMenu, 
  VNavigationDrawer, VRadioGroup, VSelect, VSlider, VSnackbar, VStepper, 
  VProgressLinear, VSubheader, VTabs, VTextField, VToolbar, VTooltip, VTextarea,
  VSwitch, VCombobox,  VTimePicker
} from 'vuetify'
import Vuex from 'vuex'
import '../node_modules/vuetify/src/stylus/app.styl'
import App from './App'
import router from './router'
import firebase from './services/firebase.js'
import store from './store'
import i18n from './i18n' 

import { createNamespacedHelpers } from "vuex";
const mapGlobalActions = createNamespacedHelpers("Global")["mapActions"];

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    VTabs,
    VCard,
    VImg,
    VDivider,
    VSubheader,
    VForm,
    VTextField,
    VChip,
    VSelect,
    VMenu,
    VDialog,
    VTooltip,
    VStepper,
    VDataTable,
    VSnackbar,
    VDataIterator,
    VCheckbox,
    VExpansionPanel,
    VAutocomplete,
    VProgressLinear,
    VSlider,
    VDatePicker,
    VRadioGroup,
    VTextarea,
    transitions,
    VSwitch,
    VCombobox,
    VTimePicker
  },
  theme: {
    primary: '#15155D',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#B71C1C',
    info: '#2196F3',
    success: '#1B5E20',
    warning: '#F9A825'
  }
})

// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

// Vue.use(Vuetify)

Vue.use(Vuex)
Vue.use(Vuefire)
// Vue.use(VueResource)

Vue.config.productionTip = false

Vue.filter('list', function(val) {
  if(!val) return ''
  if(!!val.join) return val.join(', ')
})

Vue.filter('capitalize', function(val) {
  if(!val) return ''
  return val.toUpperCase();

})

Vue.filter('invoiceTransactionType', function(invoice) {
  const invoiceTypes = {
    asset: 'Asset',
    deposit: 'Deposit',
    expense: 'Expense',
    income: 'Income',
    liability: 'Liability',
    normal: 'Normal',
    salary: 'Salary',
    transfer: 'Transfer',
    withdrawl: 'With Drawl',
    staff: 'Staff',
  };

  if(invoice.transactionType && invoiceTypes[invoice.transactionType]) {
    return invoice.transactionType
  }
  if(invoice.type === 'automatic invoice') {
    if(invoice.assetType) return invoiceTypes.asset;
    if(invoice.expenseType) return invoiceTypes.expense;
    if(invoice.incomeType) return invoiceTypes.income;
    if(invoice.liablityType) return invoiceTypes.liability;
  }
  return invoiceTypes.normal;
})

Vue.filter('localeAmount', (value) => {
  if(!!value) return value.toLocaleString();
  return 0
})

Vue.filter('amount', (value) => {
  let n = Number(value);
  if(n === 'NaN') {
    return 0.00
  } else if(Number.isInteger(n)) {
    return n.toLocaleString('en-IN') + '.00';
  } else if(n !== 'NaN') {
    if(Number.isInteger(Number(n.toFixed(2)))) {
      return  Number(n.toFixed(2)).toLocaleString('en-IN') + '.00';
    }
    return Number(n.toFixed(2)).toLocaleString('en-IN');
    } else {
      return n.toLocaleString('en-IN') + '.00';
    }
  })

let total = 12;
const reduceLoader = () => {
  total -= 1;
  if(total === 0 ) {
    const loader = document.getElementsByClassName('app-loader');
    if(loader && loader.length) {
      loader[0].remove();
    } else {
      console.info('something went wrong...')
    }
  }
}
let brand = window.localStorage.getItem('brand');
let brandFinYear = window.localStorage.getItem('brandFinYear');

if(!brand) {
  brand = "-"
}
if(!brandFinYear) {
  brandFinYear = '-'
}
//console.log("------------("+brandFinYear)
//console.log("------------("+brand)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  firebase: {
    buyer: { 
      source: firebase.database.ref('buyer').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    seller: { 
      source: firebase.database.ref('seller').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },  
    invoice: {
      source: firebase.database.ref('invoice').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },  
    item:{ 
      source: firebase.database.ref('item').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    brand:{
      source: firebase.database.ref('brand'), 
      readyCallback: reduceLoader,
    },
    firm: { 
      source: firebase.database.ref('firm').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    firmSettings: {
      source: firebase.database.ref('firmSettings').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    operator: {
      source:firebase.database.ref('operator').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    account: { 
      source:firebase.database.ref('account').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },  
    loan: {
      source: firebase.database.ref('loan').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },  
    // loanadvances: { 
    //   source:firebase.database.ref('loanadvances'), 
    //   readyCallback: reduceLoader,
    // },
    staffs: {
      source: firebase.database.ref('staffs').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    staff: { 
      source: firebase.database.ref('staff').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    assets: { 
      source: firebase.database.ref('assets').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    expenses: { 
      source:firebase.database.ref('expenses').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    liabilities: { 
      source:firebase.database.ref('liabilities').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    incomes: {
      source: firebase.database.ref('incomes').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    rate: {
      source: firebase.database.ref('rate').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    customerDeposit:{ 
      source: firebase.database.ref('customerDeposit').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    products: { 
      source: firebase.database.ref('products').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    hrs: { 
      source: firebase.database.ref('hrs').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    invoiceHistory: { 
      source: firebase.database.ref('invoiceHistory').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    salarys: {
      source: firebase.database.ref('salarys').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    liabilitys: {
      source: firebase.database.ref('liabilitys').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    termsAndConditions: {
      source: firebase.database.ref('termsAndConditions').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    provisionExpense: {
      source: firebase.database.ref('provisionExpense').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    provisionLiability: {
      source: firebase.database.ref('provisionLiability').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    provisionIncome: {
      source: firebase.database.ref('provisionIncome').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    itcPayment: {
      source: firebase.database.ref('itcPayment').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    godawn: { 
      source: firebase.database.ref('godawn').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    godawnTransaction: {
      source: firebase.database.ref('godawnTrans').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    closingDetails: {
      source: firebase.database.ref('closingDetails').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    productGroup:{
      source: firebase.database.ref('productGroup').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    productCategory:{
      source: firebase.database.ref('productCategory').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productType:{
      source: firebase.database.ref('productType').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    batchTransaction:{
      source: firebase.database.ref('batchTransaction').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    damageTransaction:{
      source: firebase.database.ref('damageTransaction').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    orders:{
      source: firebase.database.ref('orders').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    leads:{
      source: firebase.database.ref('leads').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    letterHeads:{
      source: firebase.database.ref('letterHeads').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    todos:{
      source: firebase.database.ref('todos').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    estimates:{
      source: firebase.database.ref('estimates').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productSets:{
      source: firebase.database.ref('productSets').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    customerPayments:{
      source: firebase.database.ref('customerPayments').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    brandPermission:{
      source: firebase.database.ref('brandPermission').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    branch:{
      source: firebase.database.ref('branch').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    branchTransaction: {
      source: firebase.database.ref('branchTrans').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    transaction:{
      source: firebase.database.ref('transaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    shopSettings : {
      source: firebase.database.ref('shopSettings').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productUniqueId : {
      source: firebase.database.ref('productUniqueId').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    firmInfrastructure : {
      source: firebase.database.ref('firmInfrastructure').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    portfolio : {
      source: firebase.database.ref('portfolio').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productManufactureTransaction : {
      source: firebase.database.ref('productManufactureTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productDamageTransaction : {
      source: firebase.database.ref('productDamageTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productReplaceTransaction : {
      source: firebase.database.ref('productReplaceTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productRepair : {
      source: firebase.database.ref('productRepair').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    productDrawer : {
      source: firebase.database.ref('productDrawer').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    drawerTransaction : {
      source: firebase.database.ref('drawerTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    orderSetting : {
      source: firebase.database.ref('orderSetting').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    leadSetting : {
      source: firebase.database.ref('leadSetting').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    },
    receiptCollections:{
      source: firebase.database.ref('receiptCollections').orderByChild('brand').equalTo(brand), 
      readyCallback: reduceLoader,
    },
    productRateCategory : {
      source: firebase.database.ref('productRateCategory').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader,
    }
  },
  router,
  i18n,
  store,
  
  components: { App },
  template: '<App/>',
  methods: {
    ...mapGlobalActions([
      "SET_SELECTED_BRAND",
      "SET_BRAND_FIN_YEAR"
    ])
  },
  created () {
    firebase.firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // this.$router.push('/')
        // console.log('user', user)
      let brandFinYear =  window.localStorage.getItem('brandFinYear');
        if(!brandFinYear){
         let finYear = null;
         let date = new Date()
         let year = date.getFullYear();
         let month = date.getMonth();
         let qter = Math.floor((month + 3) / 3);
          if(qter == 1) {
            finYear = ((parseInt(year)-1) + "-" + (year.toString()).slice(-2));
          } else {
            finYear = year + "-" + (parseInt(year)+1).toString().slice(-2);
          }
          brandFinYear = user.displayName + "_" + finYear
        }
        this.SET_BRAND_FIN_YEAR(brandFinYear);       
        this.SET_SELECTED_BRAND(user.displayName);
        window.localStorage.setItem('brand', user.displayName)
        window.localStorage.setItem('brandFinYear', brandFinYear)
        window.localStorage.setItem('user', user.uid)
      } else {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('brand')
        window.localStorage.removeItem('brandFinYear')
        // this.$router.push('/login')
      }
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js